module.exports = __webpack_public_path__ + "img/shoulder-ectomorph-female.c02703ec.svg";